export const MID_YEAR_SALE_END = 1717185600000
